import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import Question from "@/models/lms/Question";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";

export default class UserAnswer extends GenexLMSModel {
    static entity = 'user-answers'
    static primaryKey = 'question_id'
    static fields() {
        return {
            type: this.attr('user-answers'),
            id: this.attr(null),
            question_id: this.attr(null),
            question: this.belongsTo(Question, 'question_id'),
            answer: this.attr(null),
            correct: this.attr(0),
        }
    }
}
